<script>

import appConfig from "@/app.config.json";
import Layout from "@/views/layouts/main.vue";
import CommonTableComponent from "@/components/table.vue";
import DatePicker from "vue2-datepicker";
import tableSearch from "@/mixins/tableSearch";
import pagination from "@/mixins/pagination";
import router from "@/mixins/router";
import ModalSelectUserByDepartment from "@/views/pages/daily_reports/modals/ModalSelectUserByDepartment.vue";
import apiEndpoints from "@/services/apiEndpoints";
import datetime from "@/mixins/datetime";

export default {
  name: "DailyWorkReportMaintenanceSearch",
  page: {
    title: "作業日報メンテナンス検索",
    meta: [{ name: "description", content: appConfig.description }]
  },
  mixins: [tableSearch, pagination, router, datetime],
  components: {
    Layout,
    DatePicker,
    CommonTableComponent,
    ModalSelectUserByDepartment
  },
  data() {
    return {
      data: [],
      isLoading: false,
      filters: {
        schedule_start_datetime: this.$route.query.hasOwnProperty('schedule_start_datetime')
        ? this.$route.query.schedule_start_datetime ?? ''
        : '',
        user_name: this.$route.query.user_name || "",
        completed_date: this.$route.query.completed_date || '',
        schedule_id: this.$route.query.schedule_id || "",
        discharger: this.$route.query.discharger || "",
        discharger_site: this.$route.query.discharger_site || "",
        manifest_number: this.$route.query.manifest_number || "",
        zz_work_order_type_id: this.$route.query.zz_work_order_type_id
        ? (this.$route.query.zz_work_order_type_id.includes(',')
          ? this.$route.query.zz_work_order_type_id.split(',')
          : (Array.isArray(this.$route.query.zz_work_order_type_id)
            ? this.$route.query.zz_work_order_type_id : [this.$route.query.zz_work_order_type_id])
          )
        : [],
        zz_dairy_report_approval_status: this.$route.query.zz_dairy_report_approval_status
        ? (this.$route.query.zz_dairy_report_approval_status.includes(',')
          ? this.$route.query.zz_dairy_report_approval_status.split(',')
          : (Array.isArray(this.$route.query.zz_dairy_report_approval_status)
            ? this.$route.query.zz_dairy_report_approval_status : [this.$route.query.zz_dairy_report_approval_status])
          )
        : this.$route.query.zz_dairy_report_approval_status !== undefined ? []: ["0","3"],
        is_schedule_canceled: this.$route.query.is_schedule_canceled ?? 0,
        column: this.$route.query.column || "id",
        dir: this.$route.query.dir || "DESC",
        page: this.$route.query.page || 1,
        searchToken: 0,
        screen_parent: "maintenance",
        approval_status_search: [],
        is_schedule_canceled_search: [],
        is_migrated: this.$route.query.is_migrated ?? 0,
        transport_or_treatment: this.$route.query.transport_or_treatment ?? 1,
        is_carsByDailyReport: this.$route.query.is_carsByDailyReport ?? 0,
        is_carsByDailyReport_search: [],
      },
    };
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      this.isLoading = true;
      const response = await this.$http.get(apiEndpoints.daily_report_approve,  // DailyReportController.searchApprove
        this.filters,
      );
      const { status, data } = response;
      if (status) {
        const result = data.result;
        this.data = this.$_.isEmpty(result) ? [] : result.data;
        const meta = this.$_.isEmpty(data.result.meta) ? [] : data.result.meta;
        this.setMeta(meta);
        this.approval_status_search = this.filters.zz_dairy_report_approval_status
        this.is_schedule_canceled_search = this.filters.is_schedule_canceled
        this.is_carsByDailyReport_search = this.filters.is_carsByDailyReport
      }
      this.isLoading = false;
    },
    search(){
      this.resetToFirstPage();
      this.updateUrlFilters();
    },
    onChangePage(event, page) {
      this.filters.page = page;
      this.updateUrlFilters();
    },
    onSelectData(user) {
      this.filters.user_name = user;
    },
    clearDataSearch(){
      for (const key in this.filters) {
        this.filters[key] = ""
      }
      this.filters.zz_dairy_report_approval_status = ["0"];
      this.filters.zz_work_order_type_id = [];
      this.filters.is_schedule_canceled = 0;
      this.filters.column = "id";
      this.filters.dir = "DESC";
      this.filters.is_migrated = '0';
      this.filters.is_carsByDailyReport = '0';
      this.resetToFirstPage()
      this.updateUrlFilters();
    },
    back(){
      this.$router.push('/');
    },
    transportationAndFactory(item) {
      let text;
      //case transportation
      if (item.reportType == 1) {
        text = '運搬'
      }

      if (item.reportType == 2) {
        text ='工場'
      }
      return text;
    },
    getDischargerName(item) {
      return item.daily_report?.work_order_json?.case?.discharger?.name_abbreviated;
    },
    getDischargerSiteName(item) {
      return item.daily_report?.work_order_json?.case?.discharger_site?.name_abbreviated;
    },
    getWasteCategoryName(item) {
      //return item.waste_or_service_by_work_order?.waste?.waste_category?.name;
      return this.getTargetWasteOrServiceFromJson(item.daily_report, item.wastes_or_services_by_work_order_id)?.waste?.waste_category?.name;
    },
    getMeasurementQuantity(item) {
      return item.measurement_quantity;
    },
    getZzJwUnit(item) {
      return item.jw_unit;
    },
    getScheduleVendorSite(item) {
      return item?.vendor_site?.name_abbreviated;
    },
    getQueryPageRedirect(item) {
      if (this.isDailySpecialCase(item)) {
        return item.reportType === 2 ? {
          waste_or_service_ids: item.id,
          vendor_site_id: item.vendor_site_id,
          ...this.filters
        } : {waste_or_service_ids: item.id, ...this.filters}
      }

      return this.transportationAndFactory(item) === '工場' ? {
        waste_or_service_ids: item.id,
        vendor_site_id: item.vendor_site_id,
        ...this.filters
      } : {waste_or_service_ids: item.id, ...this.filters}
    },

    isDailySpecialCase(item) {
      return item.daily_report.work_order_json.zz_work_order_type_id === '03' && item.vendor_site_id;
    },
    getApproveStatus(item) {
      // キャンセルされている場合最優先で表示
      if (item.daily_report.is_schedule_canceled) {
        return "キャンセル"
      }
      // reportTypeが
      if (item.reportType == 1) {
        // 1は収集収集運搬側なのでそのステータスを返却
        return item.transport_approved_status.dairy_report_approval_status;
      }else if(item.reportType == 2){
        // 2は工場側なのでそのステータスを返却
        return item.treatment_approved_status.dairy_report_approval_status;
      }
    },
    addDisabled(item){
      // キャンセルされた日報では追加ボタン無効
      if(item.daily_report.is_schedule_canceled == 1){
        return true;
      }
      // 「排出」では追加ボタン無効
      //return item.daily_report.work_order_json.zz_work_order_type_id == this.$constant.work_order_type.discharge;
      if (item.daily_report.work_order_json.zz_work_order_type_id == this.$constant.work_order_type.discharge){
        return true;
      }
      // 「収集運搬処分」の「工場」では追加ボタン無効
      if (item.reportType == 2 
      && item.daily_report.work_order_json.zz_work_order_type_id == this.$constant.work_order_type.transportation_disposal){
        return true;
      }
    },
    isService(item) {
      // return item.waste_or_service_by_work_order?.service !== null;
      return this.getTargetWasteOrServiceFromJson(item.daily_report, item.wastes_or_services_by_work_order_id)?.service_id;
    },
    getCompleteDate(item) {
      if (this.isService(item)) {
        return '';
      } else if (this.transportationAndFactory(item) === '工場') {
        return item.treatment_completed_date;
      } else {
        return item.transport_completed_date;
      }
    },
    isCarsMigrateDatetime(item) {
      return item.cbdr_migrate_datetime;
    },
    getCarsByDailyReportMigrateDatetime(item){
      if (this.isCarsMigrateDatetime(item)) {
        return item.cbdr_migrate_datetime;
      } else {
      return '';  
      }
    },
    /**
     * 完了状態表示
     */
    complateStatus(item){
      if(item.reportType==1){
        if(item.daily_report.is_transport_completed){
          return "完了";
        }else{
          return "未完了";  
        }
      }else if (item.reportType==2){
        // 工場で収集運搬処分・処分の場合でかつ「廃棄物」の場合は
        // 明細にある完了フラグを見る
        // サービスの場合はそもそも「処分完了」の概念が無いため日報のフラグを見なければいけない
        if(
          (item.daily_report.schedule.zz_work_order_type_id == this.$constant.work_order_type.transportation_disposal ||
          item.daily_report.schedule.zz_work_order_type_id == this.$constant.work_order_type.disposal)
          && this.getTargetWasteOrServiceFromJson(item.daily_report, item.wastes_or_services_by_work_order_id)?.waste_id 
        ){
          if(item.treatment_complete){
            return "完了";
          }else if((
            item.daily_report.is_treatment_accepted_1 || 
            item.daily_report.is_treatment_accepted_2 || 
            item.daily_report.is_treatment_accepted_3 || 
            item.daily_report.is_treatment_accepted_4 || 
            item.daily_report.is_treatment_accepted_5
          ) && item.daily_report.schedule.zz_work_order_type_id == this.$constant.work_order_type.disposal
          ){
            // 「処分」の場合のみ搬入完了がある。
            // 収集運搬処分の場合はこの場合未完了
            // また、1日報複数工場の事を考慮して「この工場は」搬入完了しているかを見る必要がある点に注意
            // この行の搬入完了状況
            if(item.daily_report['is_treatment_accepted_'+item.vendor_site.zz_vendor_site_4_id] == "1"){
              return "搬入完了";
            }else{
              return "未完了";  
            }
          }else{
            return "未完了";
          }
        }else if(
          (item.daily_report.schedule.zz_work_order_type_id == this.$constant.work_order_type.transportation_disposal ||
          item.daily_report.schedule.zz_work_order_type_id == this.$constant.work_order_type.disposal)
          && this.getTargetWasteOrServiceFromJson(item.daily_report, item.wastes_or_services_by_work_order_id)?.service_id 
        ){
          // 収集運搬処分では「工場のサービス」は表示しないので考えない
          // 処分の場合のみ考える
          // この工場の日報の状態にあわせる
          if(item.daily_report['is_treatment_completed_'+item.vendor_site.zz_vendor_site_4_id] == "1"){
            return "完了";
          }else if(item.daily_report['is_treatment_accepted_'+item.vendor_site.zz_vendor_site_4_id] == "1"){
              return "搬入完了";
          }else{
            return "未完了";  
          }
        }else{
          // 搬出や積替えの工場作業では搬入フラグは立たないので、処分（工場）フラグだけ見て完了かどうかを判断する
          if(
            item.daily_report.is_treatment_completed_1 || 
            item.daily_report.is_treatment_completed_2 || 
            item.daily_report.is_treatment_completed_3 || 
            item.daily_report.is_treatment_completed_4 || 
            item.daily_report.is_treatment_completed_5
          ){
            return "完了";
          }else{
            return "未完了";
          }
        }
      }
    },
    getTargetWasteOrServiceFromJson(dailyReport,targetId){
      return dailyReport.work_order_json.waste_or_service_by_work_order.find((item) => item.id == targetId);
    }
  },
  computed: {
    headers() {
      return [
        {
          text: "",
          value: "",
          sortable: false
        },
        {
          text: "受付番号",
          value: "id",
          sortable: true
        },
        {
          text: "作業日",
          value: "start_datetime",
          sortable: true
        },
        {
          text: "作業分類",
          sortable: false
        },
        {
          text: "運搬/工場",
          sortable: false
        },
        {
        text: "完了状態",
          sortable: false
        },
        {
          text: "ステータス",
          sortable: false
        },
        {
          text: "作業指示名",
          sortable: false
        },
        {
          text: "排出事業者",
          sortable: false
        },
        {
          text: "排出事業場",
          sortable: false
        },
        {
          text: "廃棄物種類",
          sortable: false
        },
        {
          text: "数量",
          sortable: false
        },
        {
          text: "単位",
          sortable: false
        },
        {
          text: "処分場",
          sortable: false
        },
        {
          text: "運搬/処分終了日",
          sortable: false
        },
        {
         text: "連携日時",
         sortable: false
        },
        {
         text: "車両連携日時",
         sortable: false
        },
      ];
    },
    zz_dairy_report_approval_statuses()
    {
      let options = this.$store.getters["options/options_tables"]?.zz_dairy_report_approval_statuses ?? [];

      return options.filter(option => option.id !== '2');
    },
    zz_work_order_types(){
      return (
        this.$store.getters["options/options_tables"].zz_work_order_types ?? []
      );
    },
    queryPage() {
      return this.$route.query;
    },
  },
  watch: {
    "filters.page": {
      immediate: false,
      handler(newVal, oldVal) {
        this.updateUrlFilters();
      }
    }
  }
}
</script>

<template>
  <Layout>
    <b-card class="mb-1">
      <div class="row">
        <div class="col-md-4">
          <div class="d-flex mb-2">
            <label class="col-form-label text-nowrap me-2 custom-lbl"  for="startDate">作業日</label>
            <DatePicker
              id="startDate"
              lang="ja"
              placeholder="YYYY-MM-DD"
              format="YYYY-MM-DD"
              type="date"
              value-type="format"
              v-model="filters.schedule_start_datetime"
            >
            </DatePicker>
          </div>
        </div>
        <div class="col-md-4">
          <ModalSelectUserByDepartment
            :data-search="{
              user_name: this.filters.user_name,
            }"
            @dataSelected="onSelectData"
          />
        </div>
      </div>
      <div class="row mb-1">
        <div class="col-md-4">
          <div class="d-flex">
            <label class="col-form-label text-nowrap me-2 custom-lbl" for="schedule_id">受付番号</label>
            <b-form-input
              id="schedule_id"
              type="text"
              v-model="filters.schedule_id"
            />
          </div>
        </div>
        <div class="col-md-4">
          <div class="d-flex">
            <label class="col-form-label text-nowrap me-2 custom-lbl" for="endDate">終了日</label>
            <DatePicker
              id="endDate"
              lang="ja"
              placeholder="YYYY-MM-DD"
              format="YYYY-MM-DD"
              type="date"
              value-type="format"
              v-model="filters.completed_date"
            >
            </DatePicker>
          </div>
        </div>
      </div>

      <div class="row mb-1">
        <div class="col-md-4">
          <div class="d-flex ">
            <label class="col-form-label text-nowrap me-2 custom-lbl" for="schedule_id">排出事業者</label>
            <b-form-input
              id="schedule_id"
              type="text"
              v-model="filters.discharger"
            />
          </div>
        </div>
        <div class="col-md-4">
          <div class="d-flex">
            <label class="col-form-label text-nowrap me-2 custom-lbl" for="endDate">排出事業場</label>
            <b-form-input
              id="schedule_id"
              type="text"
              v-model="filters.discharger_site"
            >
            </b-form-input>
          </div>
        </div>
      </div>

      <div class="row mb-1">
        <div class="col-md-4">
          <div class="d-flex ">
            <label class="col-form-label text-nowrap me-2 custom-lbl" for="schedule_id">マニフェスト番号</label>
            <b-form-input
              id="manifest_number"
              type="text"
              v-model="filters.manifest_number"
            />
          </div>
        </div>
        <div class="col-md-4">
          <div class="d-flex">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8">
          <div class="d-flex">
            <label class="col-form-label me-2 custom-lbl" for="zz_work_order_type_id">作業分類 </label>
            <b-form-checkbox-group
              id="zz_work_order_type_id"
              class="d-flex align-items-center gap-3"
              v-model="filters.zz_work_order_type_id"
              :options="this.zz_work_order_types"
              text-field="work_order_type"
              value-field="id"
            ></b-form-checkbox-group>
          </div>
        </div>
      </div>
      <div class="d-flex">
        <label class="col-form-label me-2 custom-lbl" for="zz_dairy_report_approval_status">ステータス</label>
        <b-form-checkbox-group
          id="zz_dairy_report_approval_status"
          class="d-flex align-items-center gap-3"
          v-model="filters.zz_dairy_report_approval_status"
          :options="this.zz_dairy_report_approval_statuses"
          text-field="dairy_report_approval_status"
          value-field="id"
        ></b-form-checkbox-group>
        <b-form-checkbox
          id="is_schedule_canceled"
          class="align-self-center ml-1"
          v-model="filters.is_schedule_canceled"
          value="1"
          unchecked-value="0"
        >キャンセル</b-form-checkbox>
      </div>
      <div class="d-flex">
        <label class="col-form-label me-2 custom-lbl" for="is_migrated"></label>
        <b-form-checkbox
          id="is_migrated"
          v-model="filters.is_migrated"
          value="1"
          unchecked-value="0"
        >連携済みを含める</b-form-checkbox>
        <label class="col-form-label me-2 custom-lbl" for="is_carsByDailyReport"></label>
        <b-form-checkbox
          id="is_carsByDailyReport"
          v-model="filters.is_carsByDailyReport"
          value="1"
          unchecked-value="0"
        >車両連携済みを含める</b-form-checkbox>
      </div>
      <div class="d-flex mt-1">
        <label class="col-form-label me-2 custom-lbl" for="zz_dairy_report_approval_status">運搬/工場</label>
        <b-form-radio-group
              class="d-flex gap-2 align-items-center mt-1"
              :options="[{text: '両方', value: '1'}, {text: '運搬', value: '2'}, {text: '工場', value: '3'}]"
              v-model="filters.transport_or_treatment"
            ></b-form-radio-group>
      </div>
      <b-row>
        <div class="d-flex justify-content-center align-items-center">
          <b-button size="lg" variant="primary" @click="search" class="me-2">
            <div class="d-flex align-items-center justify-content-center">
              <i class="fas fa-search"></i> {{ this.$lang.button.search }}
            </div>
          </b-button>
          <b-button @click="clearDataSearch" variant="dark" size="lg">
            <i class="fas fa-eraser"></i> {{ this.$lang.button.clear }}
          </b-button>
        </div>
      </b-row>
    </b-card>
    <b-overlay
      :show="isLoading"
      rounded
      opacity="0.6"
      spinner-small
      spinner-variant="primary"
      class="d-inline-block w-100"
    >
      <b-card>
        <CommonTableComponent :height-class="`table-wrapper-500`" class="text-small">
          <thead class="table-light">
          <tr>
            <th
              v-for="(item, index) in headers"
              :key="index"
              :class="getHeaderClass(item)"
            >
              <span v-if="item.sortable" @click="clickSort(item.value)">
                {{ item.text }}
                <i :class="getSortClass(item.value)"></i>
              </span>
              <span v-else>
                {{ item.text }}
              </span>
            </th>
          </tr>
          </thead>
          <tbody>
          <template v-for="(item, index) in data">
            <tr
              class="cursor-pointer"
              @click.exact="
                redirectRoute(
                  'daily.reports.maintenance.approve',
                  { id: item.daily_report_id },
                  getQueryPageRedirect(item),
                  queryPage,
                  'searchDailyWorkReportApprove'
                )
              "
              @click.ctrl="
                redirectRouteTargetBlank(
                  'daily.reports.maintenance.approve',
                  { id: item.daily_report_id },
                  getQueryPageRedirect(item),
                  queryPage,
                  'searchDailyWorkReportApprove'
                )
              "
            >
              <td>
                <button
                  class="btn btn-primary w-100 text-nowrap"
                  :disabled=addDisabled(item)
                  @click.stop
                  @click.exact="
                  redirectRoute(
                      'daily.reports.maintenance.add',
                      { id: item.daily_report_id },
                      transportationAndFactory(item) === '工場' ? {
                        vendor_site_id: item.vendor_site_id,
                        ...filters
                      } : {...filters},
                      queryPage,
                      'searchDailyWorkReportMaintenance'
                    )
                  "
                  @click.ctrl="
                    redirectRouteTargetBlank(
                      'daily.reports.maintenance.add',
                      { id: item.daily_report_id },
                      transportationAndFactory(item) === '工場' ? {
                        vendor_site_id: item.vendor_site_id,
                        ...filters
                      } : {...filters},
                      queryPage,
                      'searchDailyWorkReportMaintenance'
                    )
                  "
                >追加</button>
              </td>
              <td class="text-center">{{ item.daily_report.schedule.id }} - {{ item.daily_report_sub_id }}</td>
              <td>{{ item.daily_report.schedule.start_datetime | dateWithWeekDay }}</td>
              <td>
              {{ zz_work_order_types.find(wot => wot.id == item.daily_report.work_order_json.zz_work_order_type_id)
                && zz_work_order_types.find(wot => wot.id == item.daily_report.work_order_json.zz_work_order_type_id).work_order_type
              }}
            </td>
              <td>{{ transportationAndFactory(item) }}</td>
              <td>{{ complateStatus(item) }}</td>
              <td>
                {{ getApproveStatus(item) }}
              </td>
              <td>{{ item.daily_report.work_order_json.name }}</td>
              <td>
                {{ getDischargerName(item) }}
              </td>
              <td>
                {{ getDischargerSiteName(item) }}
              </td>
              <td>
                  {{ getWasteCategoryName(item) }}
              </td>
              <td>
                {{ getMeasurementQuantity(item) }}
              </td>
              <td>
                {{ getZzJwUnit(item) }}
              </td>
              <td>
                  {{ getScheduleVendorSite(item) }}
              </td>
              <td>{{ getCompleteDate(item) }}</td>
              <td>{{ item.migrate_datetime }}</td>
              <td>{{ getCarsByDailyReportMigrateDatetime(item) }}</td>
            </tr>
          </template>
          <tr v-if="!data.length && !isLoading">
            <td :colspan="headers.length" class="text-center">
              データなし。
            </td>
          </tr>
          </tbody>
        </CommonTableComponent>
        <div
          class="d-flex justify-content-between mt-3"
          v-if="data.length > 0"
        >
          <div class="d-flex align-items-center">
            <b-pagination
              v-model="filters.page"
              :total-rows="meta.total"
              :per-page="meta.per_page"
            ></b-pagination>
          </div>
          <div class="d-flex align-items-center">
            <div class="me-2">
              {{ meta.from }} - {{ meta.to }} / {{ meta.total }}
            </div>
          </div>
        </div>
      </b-card>
    </b-overlay>
  </Layout>
</template>
<style scoped>
.custom-lbl {
  flex: 0 0 95px;
}
.text-small {
  font-size: 12px;
}
</style>
